/**
 * Canonical component schema definitions (authoring layer)
 *
 * Source-of-truth TypeScript constants for component schema export (PRD_FW10 Section 6.3).
 * Kept framework-agnostic so React/Vue/Svelte adapters can rely on the same contract.
 */
import { normalizeSlotDefinitions } from './schema-slot-builders';
import { BUILT_IN_COMPONENT_IDS, BUILT_IN_COMPONENT_REGISTRY, BUILT_IN_COMPONENT_SCHEMA_ID_BY_COMPONENT, } from './built-in-component-registry';
export const COMPONENT_SCHEMA_META = {
    $schema: 'https://smoothie.dev/schemas/component/v1',
    version: '2.0.0',
};
function compareStrings(left, right) {
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
}
function stableSerialize(value) {
    if (value === null || value === undefined) {
        return 'null';
    }
    if (typeof value !== 'object') {
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        return `[${value.map((entry) => stableSerialize(entry)).join(',')}]`;
    }
    const keys = Object.keys(value).sort(compareStrings);
    return `{${keys.map((key) => `${JSON.stringify(key)}:${stableSerialize(value[key])}`).join(',')}}`;
}
function buildComponentSchemas() {
    const entries = new Map();
    for (const componentId of BUILT_IN_COMPONENT_IDS) {
        const definition = BUILT_IN_COMPONENT_REGISTRY[componentId];
        const schemaId = BUILT_IN_COMPONENT_SCHEMA_ID_BY_COMPONENT[componentId];
        const schemaEntry = Object.freeze({
            type_id: definition.schema.typeId,
            props: definition.schema.props,
            ...(definition.schema.events && { events: [...definition.schema.events] }),
            ...(definition.schema.slots && { slots: normalizeSlotDefinitions(definition.schema.slots) }),
            ...(definition.schema.elements && { elements: [...definition.schema.elements] }),
            ...(definition.schema.description && { description: definition.schema.description }),
        });
        const existingEntry = entries.get(schemaId);
        if (existingEntry) {
            if (stableSerialize(existingEntry) !== stableSerialize(schemaEntry)) {
                throw new Error(`[smoothie/ui-core] Conflicting schema definitions registered for ${schemaId}`);
            }
            continue;
        }
        entries.set(schemaId, schemaEntry);
    }
    return Object.freeze(Object.fromEntries([...entries.entries()].sort(([left], [right]) => compareStrings(left, right))));
}
export const componentSchemas = buildComponentSchemas();
//# sourceMappingURL=component-schemas.js.map